module.exports = __webpack_public_path__ + "static/img/5654_phase_function_Paper_Points.8cb92ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5654_phase_function_Paper_Points.png
// module id = FgNK
// module chunks = 0